/* eslint-disable */
import React, { Component, createRef } from 'react';
import ReactGA from 'react-ga';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';
import { isMobile  } from 'react-device-detect';
import SSOFT_SOLUTION_FM_SEO_1342 from '../../sections/SSoft_Solution_FM_Seo_1342/SSoft_Solution_FM_Seo';
import SSOFT_HERO_SIDE_926 from '../../sections/SSoft_Hero_Side_926/SSoft_Hero_Side';
import SSOFT_SOLUTION_WHY_1332 from '../../sections/SSoft_Solution_Why_1332/SSoft_Solution_Why';
import SSOFT_SOLUTIONS_SLIDER_929 from '../../sections/SSoft_Solutions_Slider_929/SSoft_Solutions_Slider';
import SSOFT_SOLUTIONS_DETAIL_CARD_930 from '../../sections/SSoft_Solutions_Detail_Card_930/SSoft_Solutions_Detail_Card';
import SSOFT_SOLUTION_KEY_FEATURES_928 from '../../sections/SSoft_Solution_Key_Features_928/SSoft_Solution_Key_Features';
import SSOFT_SOLUTIONS_QUESTION_CARDS_932 from '../../sections/SSoft_Solutions_Question_Cards_932/SSoft_Solutions_Question_Cards';
import SSOFT_SOLUTIONS_MORE_INFO_931 from '../../sections/SSoft_Solutions_More_Info_931/SSoft_Solutions_More_Info';
import SSOFT_RELATED_PAGES_933 from '../../sections/SSoft_Related_Pages_933/SSoft_Related_Pages';

function withParams(Component) {
    return props => <Component {...props} params={useParams()} />;
}

class project1 extends Component {
   constructor(props) {
       super(props);
       this.state = {
           currentPage: null,
           currentSection: null,
           override: true,
           section: [
               { id: 1, slug: localStorage.getItem('language') === "English"? 'seo' : 'seo'},
               { id: 2, slug: localStorage.getItem('language') === "English"? 'hero' : 'hero'},
               { id: 3, slug: localStorage.getItem('language') === "English"? 'why-choose-us' : 'why-choose-us'},
               { id: 4, slug: localStorage.getItem('language') === "English"? 'solutions-slider' : 'solutions-slider'},
               { id: 5, slug: localStorage.getItem('language') === "English"? 'solutions-detail-cards' : 'solutions-detail-cards'},
               { id: 6, slug: localStorage.getItem('language') === "English"? 'features' : 'features'},
               { id: 7, slug: localStorage.getItem('language') === "English"? 'solutions-question-cards' : 'solutions-question-cards'},
               { id: 8, slug: localStorage.getItem('language') === "English"? 'more-info' : 'more-info'},
               { id: 9, slug: localStorage.getItem('language') === "English"? 'realted-pages' : 'realted-pages'},
           ],
       };
       this.scrollToSection = this.scrollToSection.bind(this);
       this.scrollAction = this.scrollAction.bind(this);
        this.isStateChanging = false
   }
   componentDidMount() {
       this.scrollToSection();
       ReactGA.initialize('')
       ReactGA.pageview(window.location.pathname + window.location.search);
   }
   componentWillUnmount(){
   }
   section1 = createRef()
   section2 = createRef()
   section3 = createRef()
   section4 = createRef()
   section5 = createRef()
   section6 = createRef()
   section7 = createRef()
   section8 = createRef()
   section9 = createRef()
   scrollToSection() {
       let currentLocation = window.location.href
       const hasSectionAnchor = currentLocation.includes('/#')
       if (hasSectionAnchor) {
           let anchorSectionId = `${currentLocation.substring(currentLocation.indexOf('#') + 1)}`
           setTimeout(() => { this.scrollAction(anchorSectionId) }, 1000)
       }
   }
   scrollAction(anchorSectionId) {
       const uri_dec = decodeURIComponent(anchorSectionId)
       const key = this.state.section.filter(x => x.slug == uri_dec).map(obj => `section${obj.id}`)
       const getY = (element) => element.getBoundingClientRect().top + window.pageYOffset - 140;
       if (key) {
          if (key[0] === 'section1') {
               setTimeout(() => {window.scrollTo({ top: getY(this.section1.current), behavior: 'smooth' })}, 1000)
          } else if (key[0] === 'section2') {
               setTimeout(() => {window.scrollTo({ top: getY(this.section2.current), behavior: 'smooth' })}, 1000)
          } else if (key[0] === 'section3') {
               setTimeout(() => {window.scrollTo({ top: getY(this.section3.current), behavior: 'smooth' })}, 1000)
          } else if (key[0] === 'section4') {
               setTimeout(() => {window.scrollTo({ top: getY(this.section4.current), behavior: 'smooth' })}, 1000)
          } else if (key[0] === 'section5') {
               setTimeout(() => {window.scrollTo({ top: getY(this.section5.current), behavior: 'smooth' })}, 1000)
          } else if (key[0] === 'section6') {
               setTimeout(() => {window.scrollTo({ top: getY(this.section6.current), behavior: 'smooth' })}, 1000)
          } else if (key[0] === 'section7') {
               setTimeout(() => {window.scrollTo({ top: getY(this.section7.current), behavior: 'smooth' })}, 1000)
          } else if (key[0] === 'section8') {
               setTimeout(() => {window.scrollTo({ top: getY(this.section8.current), behavior: 'smooth' })}, 1000)
          } else if (key[0] === 'section9') {
               setTimeout(() => {window.scrollTo({ top: getY(this.section9.current), behavior: 'smooth' })}, 1000)
            }
       }
   }
   render() {
       const getHelmetTitle = () => {
           var title;
           switch (localStorage.getItem('language')) {
               case 'English':
                   title = <title> Financial Management | Supersoft</title>;
                   break;
               case 'Indonesian':
                   title = <title> Manajemen Keuangan | Supersoft</title>;
                   break;
               default:
                   title = <title> Financial Management | Supersoft</title>;
                   break;
           }
           return title;
       };
       const getHelmetDescription = () => {
           var description;
           switch (localStorage.getItem('language')) {
               case 'English':
                   description = <meta name='description' content='Optimize business with Infor SunSystems: Enhance finance operations, accounting, and analytics' />;
                   break;
               case 'Indonesian':
                   description = <meta name='description' content='Maksimalkan bisnis Anda dengan Infor SunSystems: Perkuat operasi keuangan dan akuntansi serta laporan analitikal' />;
                   break;
               default:
                   description = <meta name='description' content='Optimize business with Infor SunSystems: Enhance finance operations, accounting, and analytics' />;
                   break;
           }
           return description;
       };
       const getHelmetKeywords = () => {
           var keywords;
           switch (localStorage.getItem('language')) {
               case 'English':
                   keywords = <meta name='keywords' content='' />;
                   break;
               case 'Indonesian':
                   keywords = <meta name='keywords' content='' />;
                   break;
               default:
                   keywords = <meta name='keywords' content='' />;
                   break;
           }
           return keywords;
       };
         let helmet = getHelmetTitle();
         let description = getHelmetDescription();
         let keywords = getHelmetKeywords();
       return (
           <>
               <Helmet>
                   {helmet}
                   {description}
                   {keywords}
               </Helmet>
            <div ref={this.section1}>
                <SSOFT_SOLUTION_FM_SEO_1342 />
            </div>
            <div ref={this.section2}>
                <SSOFT_HERO_SIDE_926 />
            </div>
            <div ref={this.section3}>
                <SSOFT_SOLUTION_WHY_1332 />
            </div>
            <div ref={this.section4}>
                <SSOFT_SOLUTIONS_SLIDER_929 />
            </div>
            <div ref={this.section5}>
                <SSOFT_SOLUTIONS_DETAIL_CARD_930 />
            </div>
            <div ref={this.section6}>
                <SSOFT_SOLUTION_KEY_FEATURES_928 />
            </div>
            <div ref={this.section7}>
                <SSOFT_SOLUTIONS_QUESTION_CARDS_932 />
            </div>
            <div ref={this.section8}>
                <SSOFT_SOLUTIONS_MORE_INFO_931 />
            </div>
            <div ref={this.section9}>
                <SSOFT_RELATED_PAGES_933 />
            </div>
           </>
       );
   }
}
export default withParams(project1);